var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.32 10C39.04 12.96 40 16.36 40 20C40 31.04 31.04 40 20 40C8.96 40 0 31.04 0 20C0 8.96 8.96 0 20 0C23.48 0 26.76 0.92 29.64 2.48C29.2 2.72 28.8 2.99999 28.4 3.27998L28.4 3.28C25.88 2 23.04 1.28 20.04 1.28C9.68 1.28 1.28 9.68 1.28 20C1.28 30.32 9.68 38.72 20 38.72C30.32 38.72 38.72 30.32 38.72 20C38.72 16.72 37.88 13.64 36.36 10.96L37.32 10ZM11.5195 16.3601C11.5195 11.6801 15.3195 7.88013 19.9995 7.88013C24.6795 7.88013 28.4795 11.6801 28.4795 16.3601C28.4795 22.8849 20.8818 31.4278 20.4853 31.8736L20.4795 31.8801L19.9995 32.4001L19.5195 31.8801L19.5137 31.8736C19.1172 31.4278 11.5195 22.8849 11.5195 16.3601ZM12.7995 16.3601C12.7995 21.5601 18.3195 28.4801 19.9995 30.4801C21.6795 28.4801 27.1995 21.5601 27.1995 16.3601C27.1995 12.4001 23.9595 9.16013 19.9995 9.16013C16.0395 9.16013 12.7995 12.4001 12.7995 16.3601ZM16.5605 16.3599C16.5605 14.4399 18.1205 12.9199 20.0005 12.9199C21.8806 12.9199 23.4405 14.4399 23.4405 16.3599C23.4405 18.2799 21.9205 19.7999 20.0005 19.7999C18.0805 19.7999 16.5605 18.2799 16.5605 16.3599ZM17.8405 16.3599C17.8405 17.5599 18.8005 18.5199 20.0005 18.5199C21.1605 18.5199 22.1606 17.5599 22.1606 16.3599C22.1606 15.1599 21.2005 14.1999 20.0005 14.1999C18.8005 14.1999 17.8405 15.1599 17.8405 16.3599ZM31.2807 10.84L30.3607 11.76L26.7207 8.08005L30.3607 4.44005L31.2807 5.36005L29.2007 7.44005H31.2807C34.9207 7.44005 37.9207 4.48005 37.9207 0.800049H39.2007C39.2007 5.20005 35.6407 8.76005 31.2807 8.76005H29.2007L31.2807 10.84Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 40,
    x2: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.4cabb52cfcc85cac90c16d6ec40de802.svg";
export { ForwardRef as ReactComponent };